/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_To_CalendarInputs */

const th_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มลงปฏิทิน`)
};

const en_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to calendar`)
};

const ja_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カレンダーに追加`)
};

const zh_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加到日历`)
};

const es_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir al calendario`)
};

const pt_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar ao calendário`)
};

const id_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan ke kalender`)
};

const fr_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter au calendrier`)
};

const tl_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idagdag sa kalendaryo`)
};

const vi_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm vào lịch`)
};

const ko_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`캘린더에 추가`)
};

const de_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Kalender hinzufügen`)
};

const ru_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить в календарь`)
};

const tr_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takvime ekle`)
};

const it_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi al calendario`)
};

const pl_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj do kalendarza`)
};

const uk_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Додати в календар`)
};

const hi_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैलेंडर में जोड़ें`)
};

const ar_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة إلى التقويم`)
};

const ms_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah ke kalendar`)
};

const bn_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যালেন্ডারে যোগ করুন`)
};

const zh_tw2_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入行事曆`)
};

const zh_hk2_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入日曆`)
};

const ur_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کیلنڈر میں شامل کریں`)
};

const fa_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افزودن به تقویم`)
};

const sw_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeza kwenye kalenda`)
};

const nl_add_to_calendar = /** @type {(inputs: Add_To_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aan agenda toevoegen`)
};

/**
* | output |
* | --- |
* | "Add to calendar" |
*
* @param {Add_To_CalendarInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const add_to_calendar = /** @type {((inputs?: Add_To_CalendarInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_To_CalendarInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_add_to_calendar(inputs)
	if (locale === "ja") return ja_add_to_calendar(inputs)
	if (locale === "zh") return zh_add_to_calendar(inputs)
	if (locale === "es") return es_add_to_calendar(inputs)
	if (locale === "pt") return pt_add_to_calendar(inputs)
	if (locale === "id") return id_add_to_calendar(inputs)
	if (locale === "fr") return fr_add_to_calendar(inputs)
	if (locale === "tl") return tl_add_to_calendar(inputs)
	if (locale === "vi") return vi_add_to_calendar(inputs)
	if (locale === "ko") return ko_add_to_calendar(inputs)
	if (locale === "de") return de_add_to_calendar(inputs)
	if (locale === "ru") return ru_add_to_calendar(inputs)
	if (locale === "tr") return tr_add_to_calendar(inputs)
	if (locale === "it") return it_add_to_calendar(inputs)
	if (locale === "pl") return pl_add_to_calendar(inputs)
	if (locale === "uk") return uk_add_to_calendar(inputs)
	if (locale === "hi") return hi_add_to_calendar(inputs)
	if (locale === "ar") return ar_add_to_calendar(inputs)
	if (locale === "ms") return ms_add_to_calendar(inputs)
	if (locale === "bn") return bn_add_to_calendar(inputs)
	if (locale === "zh-TW") return zh_tw2_add_to_calendar(inputs)
	if (locale === "zh-HK") return zh_hk2_add_to_calendar(inputs)
	if (locale === "ur") return ur_add_to_calendar(inputs)
	if (locale === "fa") return fa_add_to_calendar(inputs)
	if (locale === "sw") return sw_add_to_calendar(inputs)
	if (locale === "nl") return nl_add_to_calendar(inputs)
	return en_add_to_calendar(inputs)
});